// extracted by mini-css-extract-plugin
export default {"wrapper":"customScroll__wrapper__nczJu","innerContainer":"customScroll__innerContainer__CPzs7","fullPage":"customScroll__fullPage__MoaqW"};